
import { useCallback, useEffect, useState } from 'react';
import { pageHistoryStore, getpageHistoryStoreValue } from '../store/pageHistoryStore';

function usePageHistory() {
  const [pageStack, setPageStack] = useState(
    getpageHistoryStoreValue().pageStack);
  
  useEffect(() => {
    const subscription = pageHistoryStore.subscribe(
      updatedValue => setPageStack(updatedValue.pageStack)
    );
    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, []);

  const pushtoPageHistory = useCallback((id: string) => {
    pageHistoryStore.next({
      pageStack:[
        ...pageStack,
        id
      ]
    });
  }, [pageStack]);

  const popLastVisitedPage = useCallback(() => {
    const currentStack = [...pageStack];
    const lastVisitedPage = currentStack.pop();
    pageHistoryStore.next({
      pageStack:currentStack
    });
    return lastVisitedPage;
  }, [pageStack]);

  const resetPageHistory = useCallback(() => {
    pageHistoryStore.next({
      pageStack:[]
    });
  }, []);

  return {
    pushtoPageHistory,
    popLastVisitedPage,
    resetPageHistory,
    isPageHistoryEmpty: !pageStack.length
  };

}

export default usePageHistory;